import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';
import '@campact/camper/core/CmprButton';
import '@campact/camper/core/CmprFormHint';
import '@campact/camper/core/CmprLogoCollection';
import '@campact/camper/core/CmprLogoCollectionItem';
import '@campact/camper/core/CmprProgressbar';
import '@campact/camper/core/CmprResultMessage';
import '@campact/camper/cta/CmprCtaAppeal';
import '@campact/camper/cta/CmprModal';
import '@campact/camper/cta/CmprPrefilledArea';
import '@campact/camper/cta/CmprSocialLoginButton';
import '@campact/camper/icons/CmprIconSolidEnvelope';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

import { installErrorHandler } from '@appsignal/stimulus';
import appsignal from '@cta/shared/appsignal';
import { Application } from '@hotwired/stimulus';
import Rails from '@rails/ujs';
import ScrollButtonController from './controllers/scroll_button_controller';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('scroll-button', ScrollButtonController);

AppBoot.start(App, () => {
  document.getElementById('prefill-forms-modal')?.show();
});
